import enUS from 'antd/locale/en_US';
import ruRU from 'antd/locale/ru_RU';
import zhCN from 'antd/locale/zh_CN';
import arEG from 'antd/locale/ar_EG';

export const antdLocales = {
    en: enUS,
    ru: ruRU,
    zh: zhCN,
    ar: arEG,
} as const;

export const dayjsLocales = {
    en: 'en',
    ru: 'ru',
    zh: 'zh-cn',
    ar: 'ar',
} as const;
